/**
 * @fileoverview GeneralLogsSettings - Combined general settings and logs configuration
 * Groups language/keyboard settings with log retention policies
 */
import React from "react";
import { intl, DmsTabber } from "dmsbasereact";
import { Box, Typography } from "@mui/material";
import { GeneralSettings } from "../GeneralSettings/GeneralSettings";
import { LogsSettings } from "../LogsSettings/LogsSettings";
import { ApplicationSettings } from "../ApplicationSettings/ApplicationSettings";
import { Permissions } from "../../constants/Permissions";

export const GeneralLogsSettings = () => {
    const subTabs = [
        {
            title: intl.get("GeneralPreferences").d("Preferences"),
            component: <GeneralSettings />,
            permissions: [Permissions.CAN_MANAGE_GENERAL_SETTINGS]
        },
        {
            title: intl.get("Application").d("Application"),
            component: <ApplicationSettings />,
            permissions: [Permissions.CAN_MANAGE_GENERAL_SETTINGS]
        },
        {
            title: intl.get("Logs").d("Logs"),
            component: <LogsSettings />,
            permissions: [Permissions.CAN_MANAGE_LOG_SETTINGS]
        }
    ];

    return (
        <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {intl.get("GeneralLogsDescription").d(
                    "Configure system preferences (language, keyboard) and logging settings."
                )}
            </Typography>
            <DmsTabber tabs={subTabs} pageName={intl.get("GeneralLogs").d("General & Logs")} variant="scrollable" />
        </Box>
    );
};
